(function () {
  'use strict';

  function parseCsv(text) {
    var rows = [];
    var row = [];
    var cell = '';
    var quoted = false;

    for (var i = 0; i < text.length; i++) {
      var character = text[i];

      if (quoted) {
        if (character === '"' && text[i + 1] === '"') {
          cell += '"';
          i++;
        } else if (character === '"') {
          quoted = false;
        } else {
          cell += character;
        }
      } else if (character === '"') {
        quoted = true;
      } else if (character === ',') {
        row.push(cell);
        cell = '';
      } else if (character === '\n') {
        row.push(cell);
        rows.push(row);
        row = [];
        cell = '';
      } else if (character !== '\r') {
        cell += character;
      }
    }

    if (cell !== '' || row.length > 0) {
      row.push(cell);
      rows.push(row);
    }

    return rows;
  }

  function clean(value) {
    return String(value || '')
      .replace(/^\uFEFF/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

    function findColumn(headers, name) {
    return headers.indexOf(name);
  }

  function getCell(row, index) {
    return index >= 0 ? clean(row[index]) : '';
  }

  function extractSizes(value) {
    var matches =
      clean(value).match(/XXL70|XM70|XM60|M55|L70/g) || [];

    return matches.filter(function (size, index) {
      return matches.indexOf(size) === index;
    });
  }

  function mapStatus(value) {
    var status = clean(value);

    if (status === '非適合') {
      return '不適合';
    }

    if (status === '専用モデル') {
      return '専用設計';
    }

    return '適合確認済み';
  }

  function mergeUnique(target, source) {
    source.forEach(function (value) {
      if (target.indexOf(value) === -1) {
        target.push(value);
      }
    });
  }

    function convertRows(rows) {
    if (rows.length < 2) {
      return [];
    }

    var headers = rows[0].map(clean);

    var columns = {
      brand: findColumn(headers, 'メーカー'),
      model: findColumn(headers, '型番'),
      status: findColumn(headers, '判定'),
      size1: findColumn(headers, '推奨サイズ1'),
      size2: findColumn(headers, '推奨サイズ2'),
      note: findColumn(headers, '備考'),
      productUrl: findColumn(headers, '商品URL'),
      detailUrl: findColumn(headers, '詳細URL'),
      updatedAt: findColumn(headers, '更新日')
    };

    var records = {};

    rows.slice(1).forEach(function (row) {
      var brand = getCell(row, columns.brand);
      var model = getCell(row, columns.model);

      if (!brand || !model) {
        return;
      }

      var sourceStatus = getCell(row, columns.status);
      var size1 = getCell(row, columns.size1);
      var size2 = getCell(row, columns.size2);
      var status = mapStatus(sourceStatus);
      var sizes = extractSizes(size1 + ' ' + size2);
      var key = (brand + '|' + model).toLowerCase();

      if (!records[key]) {
        records[key] = {
          brand: brand,
          model: model,
          status: status,
          sizes: [],
          sizeLabel: clean(
            [size1, size2].filter(Boolean).join(' / ')
          ),
          note: getCell(row, columns.note),
          productUrl: getCell(row, columns.productUrl),
          detailUrl: getCell(row, columns.detailUrl),
          updatedAt: getCell(row, columns.updatedAt),
          dedicatedCode:
            status === '専用設計' ? size1 : ''
        };
      }

            mergeUnique(records[key].sizes, sizes);

      if (!records[key].note) {
        records[key].note =
          getCell(row, columns.note);
      }

      if (!records[key].productUrl) {
        records[key].productUrl =
          getCell(row, columns.productUrl);
      }

      if (!records[key].detailUrl) {
        records[key].detailUrl =
          getCell(row, columns.detailUrl);
      }

      if (
        records[key].status !== '専用設計' &&
        status === '専用設計'
      ) {
        records[key].status = '専用設計';
        records[key].dedicatedCode = size1;
      } else if (
        records[key].status !== '専用設計' &&
        status === '不適合'
      ) {
        records[key].status = '不適合';
      }
    });

    return Object.keys(records).map(function (key) {
      var record = records[key];

      if (
        record.status === '適合確認済み' &&
        record.sizes.length > 1
      ) {
        record.status = '複数サイズ';
      }

      if (record.sizes.length > 0) {
        record.sizeLabel = record.sizes.join(' / ');
      }

      if (
        !record.note &&
        record.status === '不適合'
      ) {
        record.note = record.sizeLabel;
      }

      return record;
    });
  }

    window.EarProfitLoadCompatibilityData =
    function (url) {
      return fetch(url, {
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'CSVの取得に失敗しました: ' +
              response.status
            );
          }

          return response.text();
        })
        .then(function (csvText) {
          return convertRows(
            parseCsv(csvText)
          );
        });
    };
})();